<template>
  <v-form ref="itemsFilterForm">
    <base-material-filter
      title="Търсене на артикули"
      :hasFilters="hasActiveFilters"
      v-on:do-filter="doFilter"
      v-on:remove-filter="clearFilters" 
    >
      <v-row @keypress.enter="doFilter" class="mx-1">
        <v-col md="4" cols="12">
          <v-text-field 
            label="Наименование"
            v-model="filters.name"
            autocomplete="off"
          />
        </v-col>
        <v-col md="4" cols="12">
          <v-text-field 
            label="Автор"
            v-model="filters.author"
            autocomplete="off"
          />
        </v-col>
        <v-col md="2" cols="12">
          <v-text-field 
            label="Инв. №"
            v-model="filters.inventoryNumber"
            autocomplete="off"
          />
        </v-col>
        <v-col md="2" cols="12">
          <v-text-field 
            label="Сигнатура"
            v-model="filters.signature"
            autocomplete="off"
          />
        </v-col>
        <v-col md="2" cols="12" class="mx-auto mb-5">
          <base-select
            :items="properties.isWritten"
            item-text="name"
            item-value="value"
            v-model="filters.isWritten"
            label="RFID запис"
            clearable
            autocomplete="off"
          >
          </base-select>
        </v-col>
      </v-row>
    </base-material-filter>
  </v-form>
</template>

<script>

import { isEmptyObject } from "@/utils";

const filtersModel = Object.freeze({
  name: '',
  author: '',
  inventoryNumber: '',
  signature: '',
  isWritten: ''
})

export default {
  name: "itemsFilter",
  props: {
    postOnClearData: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      properties: {
        isWritten: [
          {
            name: "Да",
            value: 1
          },
          {
            name: "Не",
            value: 0
          }
        ]
      },
      rules: {},
      filters: Object.assign({}, filtersModel),
      hasActiveFilters: false
    }
  },
  mounted(){},
  methods: {
    doFilter(){
      if(this.$refs.itemsFilterForm.validate()){
        if(!isEmptyObject(this.filters)){
          this.filters.page = 1;
          this.hasActiveFilters = true;
          this.$emit("doFilter");
          delete this.filters.page;
        } else {
          if(this.hasActiveFilters === true)
            this.$emit("doFilter");
            
          this.hasActiveFilters = false;
        }
      }
    },
    clearFilters(){
      this.filters = Object.assign({}, filtersModel)

      this.hasActiveFilters = false;

      this.$emit("doFilter", this.postOnClearData);
    },
  }
}
</script>